import { Files, FileStack } from 'lucide-react';

import { AgreementFormEnum, EscrowPartyTypeEnum } from 'src/graphql/schema';

export const roleOptionsDict = {
  [EscrowPartyTypeEnum.Depositor]: {
    value: EscrowPartyTypeEnum.Depositor,
    title: 'Depositor',
    description: 'The party providing the application to its clients.',
  },
  [EscrowPartyTypeEnum.Beneficiary]: {
    value: EscrowPartyTypeEnum.Beneficiary,
    title: 'Beneficiary',
    description: 'The party that uses the application.',
  },
};

export const agreementFormOptionsDict = {
  [AgreementFormEnum.Bipartite]: {
    icon: Files,
    title: 'Bipartite',
    description:
      "The beneficiary won't sign this agreement, but can still request a release if certain conditions are met.",
  },
  [AgreementFormEnum.Tripartite]: {
    icon: FileStack,
    title: 'Tripartite',
    description: 'Signed by the depositor, the beneficiary, and Codekeeper.',
  },
};
